import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface SectionTabItem {
  value: string;
  labelKey: string;
  count?: number;
  cssClass?: string | string[];
  show?: boolean;
}

@Component({
  selector: 'app-section-tabs',

  templateUrl: './section-tabs.component.html',
  styleUrl: './section-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    CommonModule,
  ],
})
export class SectionTabsComponent {
  tabs = input<SectionTabItem[]>([]);
  selected = input<string>('');

  selectedChange = output<string>();
}
